/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions interface.
 */
export function instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions(value) {
    if (!('AccessToken' in value) || value['AccessToken'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AccessToken': json['AccessToken'],
    };
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AccessToken': value['AccessToken'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerCreatePaymentRequestCrazyGamesOptions.js.map